import { defineStore } from "pinia";

import type { Inventory } from "~/sources/inventory/types.internal";

import { type State } from "./types";

export const useInventoryStore = defineStore("inventory", {
  state: (): State => ({
    inventory: null,
    inventoryList: [],
    isLoaded: false,
  }),

  getters: {
    inventoryCount(state): number {
      return state.inventoryList.length;
    },
  },

  actions: {
    async fetchInventoryById(id: Inventory["id"]): Promise<void> {
      try {
        const inventory = await this.$client.inventory.getInventoryDetail.query({
          id,
        });
        this.inventory = inventory;
        this.isLoaded = Object.keys(this.inventory ?? {}).length > 0;
      } catch (error) {
        console.error(error);
      }
    },

    async fetchInventoryList(): Promise<void> {
      try {
        const inventoryList = await this.$client.inventory.getInventoryList.query();
        this.inventoryList = inventoryList;
      } catch (error) {
        console.error(error);
      }
    },
  },
});
